import { render, staticRenderFns } from "./PassengerInformationEdit.vue?vue&type=template&id=1de27846&"
import script from "./PassengerInformationEdit.vue?vue&type=script&lang=js&"
export * from "./PassengerInformationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de27846')) {
      api.createRecord('1de27846', component.options)
    } else {
      api.reload('1de27846', component.options)
    }
    module.hot.accept("./PassengerInformationEdit.vue?vue&type=template&id=1de27846&", function () {
      api.rerender('1de27846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/PassengerInformationEdit.vue"
export default component.exports